export const isTabActive = (match, location, page) =>
  location.pathname.split(match.url)[1].split('/')[1] === page;

export const goBackToTableListURL = match => {
  if (match.url.includes('/edit/')) {
    return match.url.split('/edit')[0];
  }
  return match.url.split('/add')[0];
};
